import { useCallback, useState } from 'react';
import Head from '../../components/Head';
import Layout from '../../layout';
import NoAppointments from './NoAppointments';
import Appointments from '../../components/Appointments';

const Schedules = () => {
  const [appointmentsCount, setAppointmentsCount] = useState<number | null>(null);

  const handleAppointmentsCount = useCallback((count: number) => setAppointmentsCount(count), []);
  return (
    <Layout page="schedules" innerPage>
      <Head>Agendamentos</Head>
      {appointmentsCount === 0 && <NoAppointments />}
      <Appointments handleAppointmentsCount={handleAppointmentsCount} />
    </Layout>
  );
}

export default Schedules;